import { createTransform } from 'redux-persist';
import { IDLE_RUN_ANONYMIZATION_CHECK } from '../../constants/organizations';
import { IOrganizationsState } from '../../types/organizations';
import { stripAutomationConnectionTokens } from '../../utils/automations';

const organizationTransform = createTransform<IOrganizationsState, IOrganizationsState>(
  (stateIn: IOrganizationsState) => {
    return {
      ...stateIn,
      items: null,
      shortItems: null,
      // Merge.dev token must never reach localStorage.
      current: {
        ...stateIn.current,
        options: stripAutomationConnectionTokens(stateIn.current?.options),
      },
    };
  },
  (stateOut: IOrganizationsState) => {
    return {
      ...stateOut,
      error: null,
      isLoading: false,
      runAnonymizationCheck: IDLE_RUN_ANONYMIZATION_CHECK,
      current: {
        ...stateOut.current,
        // A token saved to localStorage before it became write-only is dropped on rehydrate.
        options: stripAutomationConnectionTokens(stateOut.current?.options),
        isDepartmentUpdating: false,
        isDepartmentSummariesLoading: false,
        error: null,
      },
    };
  },
  { whitelist: ['organizations'] },
);

const transformArray = [organizationTransform];

export default transformArray;
